<template>
    <div class="manage">
        <el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
            <!-- 新增和修改用户的表单信息 -->
            <el-form ref="form" :model="form" :inline="true" :rules="rules">
                <el-form-item label="数据库UID" prop="uid">
                    <el-input placeholder="请输入uid" v-model="form.uid"></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="phone">
                    <el-input placeholder="请输入电话号码" v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="昵称" prop="nickname">
                    <el-input placeholder="请输入昵称" v-model="form.nickname"></el-input>
                </el-form-item>
                <el-form-item label="手机型号" prop="phone_model">
                    <el-input placeholder="请输入手机型号" v-model="form.phone_model"></el-input>
                </el-form-item>
                <el-form-item label="注册时间" prop="register_time">
                    <el-date-picker v-model="form.register_time" type="datetime" placeholder="请选择注册时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="上次登录时间" prop="last_login_time">
                    <el-date-picker v-model="form.last_login_time" type="datetime" placeholder="请选择上次登录时间"></el-date-picker>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button @click="submit" type="primary">确定</el-button>
            </span>
        </el-dialog>

        <div class="manage-header">
            <!--el-button @click="dialogVisible = true" type="primary">
                + 新增
            </el-button-->
            <el-form :model="searchForm" :inline="true">
                <el-form-item>
                    <el-input placeholder="查询内容(uid或手机尾号)" v-model="searchForm.query"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- :data="tableData.users.slice((currentPage-1)*pageSize, currentPage*pageSize)" -->
        <el-table 
            :data="tableData.users"
            style="width: 100%"
            height="96%"
            :stripe="true">
            <el-table-column label="序号" type="index" align="center" width="60"></el-table-column>
            <el-table-column label="数据库UID" prop="uid" align="center" width="120"></el-table-column>
            <el-table-column label="电话号码" prop="phone" align="center" width="168"></el-table-column>
            <el-table-column label="昵称" prop="nickname" align="center" min-width="168"></el-table-column>
            <el-table-column label="性别" prop="gender" align="center" width="68">
                <template #default="{row}">
                    {{ row.gender === 0 ? "男" : (row.gender === 1 ? "女" : "?") }}
                </template>
            </el-table-column>
            <el-table-column label="手机型号" prop="phone_model" align="center"></el-table-column>
            <el-table-column label="注册时间" prop="register_time" align="center" width="168"></el-table-column>
            <el-table-column label="上次登录时间" prop="last_login_time" align="center" width="168"></el-table-column>
            <el-table-column label="验证码" prop="verify_code" align="center" width="68"></el-table-column>
            <el-table-column label="验证码时间" prop="verify_time" align="center" width="168"></el-table-column>
            <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align:center"> 
            <el-pagination
                layout = "sizes, prev, pager, next"
                :total = "tableData.total"
                :page-sizes = "[20, 50, 100]"
                :page-size = "tableData.size"
                :current-page.sync="currentPage"
                @current-change = "handleCurrentChange"
                @size-change = "handleSizeChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { getUsers } from '../api'
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                uid: '',
                phone: '',
                nickname: '',
                phone_model: '',
                register_time: '',
                last_login_time: ''
            },
            searchForm: {
                query: ''
            },
            rules: {
                uid: [
                    { required: true, message: '请输入UID' }
                ],
                phone: [
                    { required: true, message: '请输入电话号码' }
                ],
                nickname: [
                    { required: true, message: '请输入昵称' }
                ],
                phone_model: [
                    { required: true, message: '请输入手机型号' }
                ],
                register_time: [
                    { required: true, message: '请选择注册日期' }
                ],
                last_login_time: [
                    { required: true, message: '请选择上次登录日期' }
                ]
            },
            originData: {},
            tableData: [],
            // {
            //     total: 50,
            //     users: [
            //         {
            //             "last_login_time": null,
            //             "last_modify_time": null,
            //             "locked": false,
            //             "nickname": "user_15268470818",
            //             "phone": "15268470818",
            //             "phone_mac": null,
            //             "phone_model": null,
            //             "profile_url": "",
            //             "register_time": "2023-07-26 13:57:16",
            //             "uid": 1,
            //             "verify_code": null,
            //             "verify_time": null
            //         },
            //         {
            //             "last_login_time": null,
            //             "last_modify_time": null,
            //             "locked": false,
            //             "nickname": "user_15268470819",
            //             "phone": "15268470819",
            //             "phone_mac": null,
            //             "phone_model": null,
            //             "profile_url": "",
            //             "register_time": "2023-07-26 14:27:26",
            //             "uid": 2,
            //             "verify_code": null,
            //             "verify_time": null
            //         }
            //     ]
            // },
            // currentPage: this.$store.state.tab.currentUserPage,
            currentPage: 1,
            pageSize: 20
        };
    },
    methods: {
        submit() {
            this.$refs.form.validate((valid) => {
                console.log(valid);
                if (valid) {
                    console.log(this.form, 'form');
                    this.handleClose();
                    this.dialogVisible = false;
                }
            })
        },
        handleClose() {
            this.$refs.form.resetFields();
            console.log(this.form);
        },
        cancel() {
            this.handleClose();
            this.dialogVisible = false;
        },
        handleCurrentChange(val) {
            console.log('currentPage:', val, 'page size:', this.pageSize);
            this.currentPage = val;
            // this.$store.state.tab.currentUserPage = val;
            getUsers(this.pageSize, this.currentPage).then(res => {
                this.tableData = res.data.data;
                this.pageSize = this.tableData.per_page;
            }).catch(error => {
                console.error('handle page changed failed.', error);
            })
        },
        handleClick(row) {
            console.log(row);
            var infoUrl = '/userinfo?uid=' + row.uid;
            console.log(infoUrl);
            this.$router.push(infoUrl);
        },
        handleSizeChange(val) {
            
            getUsers(val, 1).then(res => {
                this.tableData = res.data.data;
                this.pageSize = val;
                this.currentPage = 1;
                console.log('handle change page size: ', this.pageSize, this.tableData)
            }).catch(error => {
                console.error('handle size change failed.', error);
            });
            // this.$store.state.tab.currentUserPage = 1;
        },
        handleSearch() {
            var query = this.searchForm.query;
            console.log('query key words: ', query)
            if (query != '') {
                getUsers(this.pageSize, 1, query).then(res => {
                    this.tableData = res.data.data;
                    this.pageSize = this.tableData.per_page;
                    this.currentPage = this.tableData.page_num;
                    console.log('table data', this.tableData);
                }).catch(error => {
                    console.log('query users failed,', error);
                });
            } else {
                this.handleCurrentChange(1);
            }
            // console.log("query words:", this.searchForm.query);
            // if(query == '')
            //     this.tableData = this.originData;
            // else {
            //     this.tableData = {};
            //     this.tableData['users'] = this.originData['users'].filter(user => user['phone'].toString().includes(query.toString()))
            // }
        }
    },
    mounted() {
        console.log('page_size', this.pageSize, 'page num', this.currentPage)
        getUsers(this.pageSize, this.currentPage).then(res => {
                this.tableData = res.data.data;
                this.pageSize = this.tableData.per_page;
                console.log('pageSize:', this.pageSize)
            }).catch(error => {
                console.error('handle page changed failed.', error);
            });
        // getUsers(1000, 1).then((data) => {
        //     console.log(data.data.data);
        //     this.tableData = data.data.data;
        //     for(var i = 0; i < this.tableData.users.length; i++) {
        //         this.tableData.users[i]['index'] = i+1;
        //     }
        //     this.originData = this.tableData;
        // });
    }
}
</script>

<style lang="less" scoped>
.manage {
    height: 90%;
}
</style>